import { set } from '@dimjs/utils';
import {
  BRIDGE_API_NAME_SPACE,
  BRIDGE_READY_EVENT_NAME,
} from '../../constants/namespace.js';
import {
  handleMessageFromNative,
  hasJavascriptMethod,
  registerSync,
} from './register.js';

export const bootstrap = (fabricApi) => {
  /**
   * 如果window对象存在FabricWebViewJavascriptBridge则不能重复注册
   */
  if (window[BRIDGE_API_NAME_SPACE]) {
    return;
  }

  // 挂在API接口到window.FabricWebViewJavascriptBridge命名空间上.
  set(window, BRIDGE_API_NAME_SPACE, fabricApi);

  // 注册全局对象, 用来提供Native主动发送消息给Web端
  set(window, '_handleMessageFromNative', handleMessageFromNative);

  /**
   * 默认注册一个`_hasJavascriptMethod`给Native查询web是否存在某一个插件定义.
   * 同时告知Native客户端插件容器已经准备好(ready), 异步回调给Native端
   */
  registerSync('_hasJavascriptMethod', (method: string) => {
    const result = hasJavascriptMethod(method);
    return {
      code: '0',
      data: result,
    };
  });

  // 提供事件异步通知当前bridge已经准备就绪.
  const doc = document;
  const readyEvent = document.createEvent('Events');
  // eslint-disable-next-line @typescript-eslint/no-deprecated
  readyEvent.initEvent(BRIDGE_READY_EVENT_NAME);
  readyEvent['fabric'] = fabricApi;
  doc.dispatchEvent(readyEvent);
};
